import { recipeType } from "../interfaces/recipe.interface";
import { sharedObjects } from "./public-objects";

export const nullRecipe: recipeType = {
  approach: "thicknessFactor",
  thicknessFactor: null,

  doughWeight: null,
  numberOfBalls: null,
  shape: "round",
  pizzaSize: null,

  panWidth: null,
  panLength: null,

  pizzaSizeTop: null,
  panWidthTop: null,
  panLengthTop: null,
  panHeight: null,

  deepDish: false,
  doughHeight: null,
  yeast: "idy",
  yeastAmount: null,

  stuffed: false,
  hydration: null,

  salt: "regular",
  saltAmount: null,
  residueAmount: null,

  preferment: "none",
  prefermentAmount: null,
  prefermentWaterAmount: null,
  prefermentYeastAmount: null,
  prefermentFlourAmount: null,

  slopedSides: false,

  stuffedAmount: null,
  title: "",
  notes: "",

  useMetric: true,
  flourId: 0,
  flours: [
    {
      id: 1,
      name: "Flour",
      percent: 100,
      isPreferment: false,
    },
    {
      id: 2,
      name: "Flour",
      percent: 100,
      isPreferment: true,
    },
  ],
  floursAsJSON: "",

  waterId: 0,
  waters: [
    {
      id: 1,
      name: "Water",
      percent: 100,
      isPreferment: false,
    },
    {
      id: 2,
      name: "Water",
      percent: 100,
      isPreferment: true,
    },
  ],
  watersAsJSON: "",

  addedIngredient: [...sharedObjects.resetAddedIngredients],
  nutritionSlices: null,
};

export const defaultRecipes = {
  nystyle: {
    description:
      "The tried and true New York style, default for the app. Thin crust, 62% hydration.",
    approach: "thicknessFactor",
    thicknessFactor: 0.08,
    doughWeight: null,
    numberOfBalls: 1,
    shape: "round",
    pizzaSize: 14,
    panWidth: null,
    panLength: null,
    pizzaSizeTop: null,
    panWidthTop: null,
    panLengthTop: null,
    panHeight: null,
    deepDish: false,
    doughHeight: null,
    yeast: "idy",
    yeastAmount: 0.4,
    stuffed: false,
    hydration: 62.0,
    salt: "regular",
    saltAmount: 1.5,
    residueAmount: null,
    preferment: "none",
    prefermentAmount: null,
    prefermentWaterAmount: null,
    prefermentYeastAmount: null,
    prefermentFlourAmount: null,
    slopedSides: false,
    stuffedAmount: null,
    title: "New York Style",
    notes: "",
    useMetric: false,
    flourId: 0,
    waterId: 0,

    flours: [
      {
        id: 1,
        name: "Flour",
        percent: 100,

        isPreferment: false,
      },
      {
        id: 2,
        name: "Flour",
        percent: 100,

        isPreferment: true,
      },
    ],

    waters: [
      {
        id: 1,
        name: "Water",
        percent: 100,

        isPreferment: false,
      },
      {
        id: 2,
        name: "Water",
        percent: 100,

        isPreferment: true,
      },
    ],

    addedIngredient: [...sharedObjects.defaultAddedIngredients],
    nutritionSlices: null,
  },

  detroit10: {
    description: "Detroit deep dish. Provided by Anders Lyman.",
    isTemporary: false,
    approach: "thicknessFactor",
    thicknessFactor: 0.1314,
    doughWeight: null,
    numberOfBalls: 1,
    shape: "rectangular",
    pizzaSize: 15.2,
    pizzaSizeTop: 16.3,
    panWidth: 9.25,
    panLength: 9.25,
    panWidthTop: 10,
    panLengthTop: 10,
    panHeight: 1.5,
    doughHeight: 0.5,
    hydration: 74,
    yeast: "idy",
    yeastAmount: 1.7,
    preferment: "none",
    prefermentAmount: null,
    prefermentWaterAmount: null,
    prefermentYeastAmount: null,
    prefermentFlourAmount: null,
    salt: "kosherMorton",
    saltAmount: 3,
    residueAmount: null,
    stuffed: false,
    deepDish: true,
    slopedSides: true,
    stuffedAmount: null,
    title: 'Detroit 10" Square',
    notes: "",
    useMetric: false,
    addedIngredient: [],
    tableConfig: {
      show: {
        grams: false,
        kilograms: false,
        milliliters: false,
        ounces: true,
        pounds: false,
        teaspoons: false,
        tablespoons: false,
        cups: false,
        drops: false,
        title: true,
        dimensions: true,
        notes: true,
      },
      precision: 3,
      precisionString: "1.0-3",
    },
    nutritionSlices: null,
  },

  nyplus: {
    description:
      "New York style with a boost of richness. Provided by Anders Lyman.",
    isTemporary: false,
    approach: "thicknessFactor",
    thicknessFactor: 0.08,
    doughWeight: null,
    numberOfBalls: 1,
    shape: "round",
    pizzaSize: 14,
    pizzaSizeTop: null,
    panWidth: null,
    panLength: null,
    panWidthTop: null,
    panLengthTop: null,
    panHeight: null,
    doughHeight: null,
    hydration: 62,
    yeast: "idy",
    yeastAmount: 1.2,
    preferment: "none",
    prefermentAmount: null,
    prefermentWaterAmount: null,
    prefermentYeastAmount: null,
    prefermentFlourAmount: null,
    salt: "regular",
    saltAmount: 2,
    residueAmount: null,
    stuffed: false,
    deepDish: false,
    slopedSides: false,
    stuffedAmount: null,
    title: "NY+",
    notes: "",
    useMetric: false,
    addedIngredient: [
      {
        value: "diastatic_milk_powder",
        description: "Diastatic Malt Powder",
        ratio: 0.0881834,
        key: "o14",
        note: null,
        dropsInTsp: null,
        amount: 0.8,
      },
      {
        value: "olive_oil",
        description: "Olive Oil",
        ratio: 0.1587301,
        key: "o25",
        note: "Typical: 1.5",
        dropsInTsp: null,
        amount: 0.5,
      },
      {
        value: "sugar",
        description: "Sugar",
        ratio: 0.140625,
        key: "o32",
        note: "Typical: 1",
        dropsInTsp: null,
        amount: 0.5,
      },
    ],
    tableConfig: {
      show: {
        grams: false,
        kilograms: false,
        milliliters: false,
        ounces: true,
        pounds: false,
        teaspoons: false,
        tablespoons: false,
        cups: false,
        drops: false,
        title: true,
        dimensions: true,
        notes: true,
      },
      precision: 3,
      precisionString: "1.0-3",
    },
    nutritionSlices: null,
  },

  onehour: {
    description: "Fraction of the time, just as tasty.",
    isTemporary: false,
    approach: "thicknessFactor",
    thicknessFactor: 0.08,
    doughWeight: 300,
    numberOfBalls: 1,
    shape: "round",
    pizzaSize: 13,
    pizzaSizeTop: null,
    panWidth: null,
    panLength: null,
    panWidthTop: null,
    panLengthTop: null,
    panHeight: null,
    doughHeight: null,
    hydration: 61.5,
    yeast: "idy",
    yeastAmount: 2.15,
    preferment: "none",
    prefermentAmount: null,
    prefermentWaterAmount: null,
    prefermentYeastAmount: null,
    prefermentFlourAmount: null,
    salt: "kosherMorton",
    saltAmount: 1.6,
    residueAmount: null,
    stuffed: false,
    deepDish: false,
    slopedSides: false,
    stuffedAmount: null,
    title: "1-Hour Beer Dough",
    notes:
      "If your beer is bitter, increase the sugar.\n\nAfter dividing the dough, let rise for at least half an hour before topping and baking.",
    useMetric: false,
    addedIngredient: [
      {
        value: "olive_oil",
        description: "Olive Oil",
        ratio: 0.1587301,
        key: "o25",
        note: "Typical: 1.5",
        dropsInTsp: null,
        amount: 4.2,
      },
      {
        value: "sugar",
        description: "Sugar",
        ratio: 0.140625,
        key: "o32",
        note: "Typical: 1",
        dropsInTsp: null,
        amount: 2.3,
      },
    ],
    tableConfig: {
      show: {
        grams: true,
        kilograms: false,
        milliliters: false,
        ounces: false,
        pounds: false,
        teaspoons: false,
        tablespoons: false,
        cups: false,
        drops: false,
        title: true,
        dimensions: true,
        notes: true,
      },
      precision: 3,
      precisionString: "1.0-3",
    },
    flourId: 2,
    waterId: 2,
    flours: [
      { id: 0, name: "Flour", percent: 100, isPreferment: false },
      { id: 1, name: "Flour", percent: 100, isPreferment: true },
    ],
    waters: [
      { id: 0, name: "Pilsner Beer", percent: 100, isPreferment: false },
      { id: 1, name: "Water", percent: 100, isPreferment: true },
    ],
    nutritionSlices: null,
  },

  deliveryStyle: {
    description:
      "For when you want to order in. Sweeter and saltier than NY style. Sauce recipe included.",
    isTemporary: false,
    approach: "thicknessFactor",
    thicknessFactor: 0.0896,
    doughWeight: 391,
    numberOfBalls: 1,
    shape: "round",
    pizzaSize: 14,
    pizzaSizeTop: null,
    panWidth: null,
    panLength: null,
    panWidthTop: null,
    panLengthTop: null,
    panHeight: null,
    doughHeight: null,
    hydration: 63,
    yeast: "idy",
    yeastAmount: 1.17,
    preferment: "none",
    prefermentAmount: null,
    prefermentWaterAmount: null,
    prefermentYeastAmount: null,
    prefermentFlourAmount: null,
    salt: "regular",
    saltAmount: 2.8,
    residueAmount: 0,
    stuffed: false,
    deepDish: false,
    slopedSides: false,
    stuffedAmount: null,
    title: "Delivery Style",
    notes:
      "### Pizza dough\n\nCombine ingredients into a mixer, and mix on low for 3 minutes. Mix on high for another 4. Transfer to a oiled bowl, cover and let sit for an hour, giving it four strengthening folds halfway through. Divide into balls and put into oiled bowls or containers, throw them in the fridge for 4-24 hours (longer is fine, just keep an eye on them).\n\nBefore cooking, let them sit at room temperature for 90 minutes.\n\n### Pizza sauce\n\n150g or 2/3c tomato paste\n\n150g or 2/3c water\n\n1g or 1/8 tsp salt\n\n10g or 2 1/3 tsp sugar\n\n10g or 2 1/4 tsp olive oil\n\n1/4 tsp dried basil\n\n1/4 tsp dried oregano\n\n1g or 1/2 tsp black pepper\n\n1g or 1/3 tsp garlic powder\n\n1g or 1/2 tsp onion powder\n\nCombine ingredients and blend with an immersion blender. Can be stored in fridge, and doing so for at least 24 hours helps build the flavor.",
    useMetric: false,
    addedIngredient: [
      {
        value: "olive_oil",
        description: "Olive Oil",
        ratio: 0.1587301,
        key: "o25",
        note: "Typical: 1.5",
        dropsInTsp: null,
        amount: 6.98,
      },
      {
        value: "sugar",
        description: "Sugar",
        ratio: 0.140625,
        key: "o32",
        note: "Typical: 1",
        dropsInTsp: null,
        amount: 8.15,
      },
    ],
    tableConfig: {
      show: {
        grams: true,
        kilograms: false,
        milliliters: false,
        ounces: false,
        pounds: false,
        teaspoons: false,
        tablespoons: false,
        cups: false,
        drops: false,
        title: true,
        dimensions: true,
        notes: true,
      },
      precision: 3,
      precisionString: "1.0-3",
    },
    flourId: 2,
    waterId: 2,
    flours: [
      { id: 0, name: "Flour", percent: 100, isPreferment: false },
      { id: 1, name: "Water", percent: 100, isPreferment: true },
    ],
    waters: [
      { id: 0, name: "Water", percent: 100, isPreferment: false },
      { id: 1, name: "Flour", percent: 100, isPreferment: true },
    ],
    nutritionSlices: null,
  },
};
